import { render, staticRenderFns } from "./delete-setting.vue?vue&type=template&id=09e17558&scoped=true&xmlns%3Av-card-actions=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./delete-setting.vue?vue&type=script&lang=js&"
export * from "./delete-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e17558",
  null
  
)

export default component.exports